import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FiCpu } from 'react-icons/fi';
import { generateAlertText } from '../../services/aiService';

const AlertModal = ({ 
  alertModalOpen, 
  setAlertModalOpen, 
  alertMessage, 
  setAlertMessage, 
  selectedUser, 
  selectedApp, 
  sendAlert 
}) => {
  const { isDarkMode } = useTheme();
  const [aiTitle, setAiTitle] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  if (!alertModalOpen) return null;

  const handleGenerateText = async () => {
    if (!aiTitle.trim()) return;
    
    setIsGenerating(true);
    
    try {
      const recipientName = selectedUser?.fullName || selectedApp?.name || 'Cliente';
      const generatedText = await generateAlertText(aiTitle, recipientName);
      setAlertMessage(generatedText);
    } catch (error) {
      console.error('Failed to generate text', error);
      // Optional: Show a toast or error message to user
    } finally {
      setIsGenerating(false);
    }
  };

  // Classes condicionais para dark mode
  const modalBg = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const textColor = isDarkMode ? 'text-gray-100' : 'text-gray-900';
  const textColorSecondary = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const borderColor = isDarkMode ? 'border-gray-600' : 'border-gray-300';
  const inputBg = isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900';
  const buttonCancel = isDarkMode 
    ? 'text-gray-300 hover:text-gray-100' 
    : 'text-gray-600 hover:text-gray-800';
  const buttonSend = 'bg-blue-600 text-white rounded-md hover:bg-blue-700';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`rounded-lg p-6 w-96 max-w-full ${modalBg}`}>
        <h3 className={`text-lg font-semibold mb-4 ${textColor}`}>
          📨 Enviar Alerta para {selectedUser?.fullName || selectedApp?.name}
        </h3>
        
        <div className={`mb-6 p-4 rounded-lg border ${isDarkMode ? 'bg-gray-700/30 border-gray-600' : 'bg-blue-50 border-blue-100'}`}>
          <div className="flex items-center gap-2 mb-3">
            <FiCpu className={isDarkMode ? 'text-blue-400' : 'text-blue-600'} />
            <h4 className={`text-sm font-medium ${textColor}`}>Gerador de Texto IA (Simulado)</h4>
          </div>
          
          <div className="flex gap-2">
            <input
              type="text"
              value={aiTitle}
              onChange={(e) => setAiTitle(e.target.value)}
              placeholder="Digite um tópico (ex: Manutenção)"
              className={`flex-1 px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${inputBg} ${borderColor}`}
            />
            <button
              onClick={handleGenerateText}
              disabled={isGenerating || !aiTitle.trim()}
              className={`px-3 py-2 text-sm rounded-md transition-colors flex items-center gap-2
                ${isGenerating || !aiTitle.trim() 
                  ? 'bg-gray-400 cursor-not-allowed text-gray-200' 
                  : 'bg-purple-600 hover:bg-purple-700 text-white shadow-sm'
                }`}
            >
              {isGenerating ? 'Gerando...' : 'Gerar'}
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label className={`block text-sm font-medium mb-2 ${textColorSecondary}`}>
            Mensagem do Alerta
          </label>
          <textarea
            value={alertMessage}
            onChange={(e) => setAlertMessage(e.target.value)}
            placeholder="Digite a mensagem do alerta..."
            rows="4"
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${inputBg} ${borderColor}`}
          />
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => {
              setAlertModalOpen(false);
              setAlertMessage('');
              setAiTitle('');
            }}
            className={`px-4 py-2 transition-colors duration-200 ${buttonCancel}`}
          >
            Cancelar
          </button>
          <button
            onClick={() => sendAlert(selectedUser?.id, selectedApp?.id)}
            className={`px-4 py-2 transition-colors duration-200 ${buttonSend}`}
          >
            Enviar Alerta
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;